<template>
    <span v-if="value === 0">
        {{ $t('gender.female') }}
    </span>

    <span v-else-if="value === 1">
        {{ $t('gender.male') }}
    </span>

    <span v-else>
        {{ $t('gender.unknown') }}
    </span>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
    props: {
        value: {
            type: Number,
            required: true,
        }
    },

    setup()
    {
        return {};
    },
})
</script>
